<div
    class="admin-modul dv-meldungsfenster background-grey padding-x-2-3 padding-t-25"
>
    <div class="view-title">
        <h2>
            {{ 'MELDUNGSFENSTER_DETAIL' | translate }}
        </h2>
        <hr class="header" />
    </div>

    @if (meldungsfensterResourceRef.isLoading()) {
        {{ 'LOADING' }}
    } @else if (meldungsfensterResourceRef.error()) {
        {{ 'ERROR_LOADING_MELDUNGSFENSTER' | translate }}
    } @else if (meldungsfensterResourceRef.hasValue()) {
        <lib-admin-ui-meldungsfenster-form
            class="background-grey"
            [meldungsfenster]="meldungsfensterResourceRef.value()!"
            [mode]="'READONLY'"
            (userCancelled)="stateService.go('admin.meldungfenster')"
        ></lib-admin-ui-meldungsfenster-form>
    }
</div>
